<template>
  <MDropdown full-height tag="div">
    <template #trigger="{ toggle }">
      <MNavLink @click="toggle">
        <div class="notifications">
          <MIcon icon="bell" size="h4" title="Notifications" block />
          <div v-if="notifications" class="notifications__badge">
            <Animation type="boing">
              <MBadge>
                {{ notifications }}
              </MBadge>
            </Animation>
          </div>
        </div>
      </MNavLink>
    </template>
    <template #content="{ hide }">
      <MDropdownContent align="right">
        <MDropdownLink
          v-if="vetDocumentRequests"
          size="large"
          href="/hub/document-requests"
          tag="router-link"
          @click="hide"
        >
          <div class="site-header__dropdown-link">
            <strong>{{ vetDocumentRequests.length }}</strong>
            {{
              $t('notifications.document_requests', [
                vetDocumentRequests.length === 1 ? '' : 's',
              ])
            }}
          </div>
        </MDropdownLink>
        <MSpacing
          v-if="!notifications"
          top="sm"
          right="md"
          bottom="sm"
          left="md"
        >
          <p>{{ $t('notifications.none') }}</p>
        </MSpacing>
      </MDropdownContent>
    </template>
  </MDropdown>
</template>

<script lang="ts" setup>
import {
  MIcon,
  MBadge,
  MDropdown,
  MDropdownContent,
  MDropdownLink,
  MNavLink,
  MSpacing,
} from '@boughtbymany/many-patterns'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import Animation from '@/components/layout/Animation/Animation.vue'
import { useDocumentRequests } from '@/store/documentRequests'

const documentRequestsStore = useDocumentRequests()

const { vetDocumentRequests } = storeToRefs(documentRequestsStore)

const notifications = computed(() => {
  return vetDocumentRequests.value.length
})
</script>

<style lang="scss" scoped>
.notifications {
  position: relative;

  &__badge {
    position: absolute;
    right: 0;
    top: 0;
    transform: translate(60%, -60%);
  }
}
</style>
